import React, { useState } from 'react'
import styles from './LeadQualityScreen.module.css'
import LeadQualityDoughnutChart from './LeadQualityDoughnutChat'
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LeadSummaryDataInsufficientComponent from './LeadSummaryDataInsufficientComponent';
import CenteredPopUp from '../../Components/CenteredPopUp/CenteredPopUp';
import LeadRecommendationPopupContent from './LeadRecommendationPopupContent';

interface LeadSummaryCallingCardComponentProps {
    data: any,
}

const LeadSummaryCallingCardComponent: React.FC<LeadSummaryCallingCardComponentProps> = ({ data }) => {
    const [openReadMore, setOpenReadMore] = useState<boolean>(false);
    const readMoreHandler  = () => {
        document.body.classList.add("no-overflow");
        setOpenReadMore(true)
    }
    let leadCallingScoreType = data?.leadCallingScoreType ? data.leadCallingScoreType.toLowerCase() : "";

    

    return (
        <div className={styles.LqscsCard}>
            <div className={styles.LqscsCardHeader}>
                <div className={styles.LqscsCardTitle}>{data.cardTitle}</div>
                <div className={styles.LqscsCardSubTitle}>{data.cardSubtitle}</div>
            </div>
            {
                (data.report_display === "N") ?
                    <LeadSummaryDataInsufficientComponent
                        leadHighlightText={data.thresholdDesc}
                        infoBannerText="Contact all the provided leads for higher conversion rate"
                        data={data}
                    />
                    :
                    <div className={styles.LqscsCardBody}>
                        <div className={styles.LqscsCardBodyLeft}>
                            <div><LeadQualityDoughnutChart totalLeads={data.totalLeads} leadgetCall={data.leadgetCall} backgrounds={['#279ea0', '#e9ecef']} labels={['Total leads', 'Called']} /></div>
                            <div className={styles.LqscsCallingDatabox}>
                                <div className={styles.LqscsCallData}>
                                    <div className={styles.LqscsCallDataValue}>{data.totalLeads}</div>
                                    <div className={styles.LqscsCallDataLabel}>Total leads</div>
                                </div>
                                <div className={styles.LqscsCallData}>
                                    <div className={`${styles.LqscsCallDataValue} ${styles.LqscsCallDataValueG}`}>{data.leadgetCall}</div>
                                    <div className={styles.LqscsCallDataLabel}>Called</div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.LqscsCardBodyRight}>
                            <div className={styles.LqscsPercentageInfo}>
                                <div className={styles.LqscsPercentageData}>
                                    <div className={styles.LqscsPercentageDataVal}>{data.leadCalledPercent}</div>
                                    <div className={styles.LqscsPercentageDataLabel}>Leads Called</div>
                                </div>
                                <div className={styles.LqscsScroreType}>
                                    <div className={`${styles.LqscsTitleTag} ${styles[leadCallingScoreType]}`}>{leadCallingScoreType}</div>
                                    {(leadCallingScoreType !== "moderate") && <div className={`${styles.LqscsScroreTypeTxt} ${styles[leadCallingScoreType]}`}>Among {(leadCallingScoreType == "good") && "Top"} {(leadCallingScoreType == "poor") && "Bottom"} 20%</div>}
                                </div>
                            </div>
                            <div className={styles.LqscsHighlight}>Top agents in your city call {data.topBenchmark} of their leads.</div>
                            <div className={`${styles.LqscsBanner} ${styles[leadCallingScoreType]}`}>
                                <span className={`${styles.LqscsBannerIcon} ${styles[leadCallingScoreType]}`}>
                                    {(leadCallingScoreType == "good") && <ThumbUpIcon className={styles.ThumbUpIcon} />}
                                    {(leadCallingScoreType == "moderate") && <InfoOutlinedIcon className={styles.infoIcon} />}
                                    {(leadCallingScoreType == "poor") && <InfoOutlinedIcon className={styles.infoIcon} />}
                                </span>
                                {
                                    data.leadCallingScoreMessage
                                    // (leadCallingScoreType == "good") ? "Great! Keep calling all your leads to maximize conversions."
                                    //     :
                                    //     (leadCallingScoreType == "moderate") ? "Contact all the provided leads for higher conversion rate"
                                    //         :
                                    //         (leadCallingScoreType == "poor") ? "Contact all the provided leads for higher conversion rate"
                                    //             :
                                    //             ""
                                }
                                <span className={styles.ReadMoreCta} onClick={readMoreHandler}>Read More</span>
                            </div>
                        </div>
                    </div>
            }
            {
                openReadMore && <CenteredPopUp
                    setModal={setOpenReadMore}
                    children={
                        <LeadRecommendationPopupContent 
                        title={"Lead Calling"}
                        subtext={"This metric shows the percentage of leads called via ReadPro."}
                        recommendation={"Since the report is based on your calls through ReadPro CRM, making calls here helps track key metrics like response time and follow-ups. This allows you to improve efficiency and increase lead conversions"}
                        scoreType={leadCallingScoreType}
                        />
                    }
                    modiferClass={styles.LcqModal}
                    closeIcon={true}
                    closeClassMofifier={styles.LcqModalClose}
                />
            }
        </div>
    )
}

export default LeadSummaryCallingCardComponent